export const PMS_CONNECT_REQUEST = 'PMS_CONNECT_REQUEST';
export const PMS_CONNECT_SUCCESS = 'PMS_CONNECT_SUCCESS';
export const PMS_CONNECT_FAILURE = 'PMS_CONNECT_FAILURE';
